var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('default-home-section-top'),_c('default-home-section-intro'),_c('default-home-section-about'),_c('default-home-section-schema'),_c('default-home-section-news'),_c('default-home-section-docs'),_c('default-home-section-antikor'),_c('default-home-section-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }